import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Font = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.583 35.985-3.103-8.31-7.707-20.424c-.2-.4-.5-.701-1-.701-.4 0-.801.3-1.001.7L3.165 27.576l-3.102 8.41c-.2.601.1 1.202.6 1.402.5.2 1.101-.1 1.401-.6l2.903-7.61h13.812l2.902 7.61c.2.5.8.8 1.401.6.4-.3.7-.901.5-1.402Zm-17.916-9.01 6.106-16.32 6.105 16.32H5.668ZM43 18.765c-.601 0-1.002.5-1.002 1.1v2.304a9.169 9.169 0 0 0-7.106-3.404c-5.104 0-9.208 4.205-9.208 9.31 0 5.107 4.104 9.312 9.208 9.312 2.903 0 5.405-1.301 7.106-3.404v2.303c0 .6.5 1.101 1.001 1.101.5 0 1.001-.5 1.001-1.101v-16.42c0-.6-.5-1.101-1-1.101Zm-8.208 16.52c-3.903 0-7.106-3.204-7.106-7.21 0-4.004 3.203-7.208 7.106-7.208 3.904 0 7.106 3.204 7.106 7.209 0 4.005-3.203 7.209-7.106 7.209Z"
  }));
});
Font.displayName = 'Font';
Font.defaultProps = {
  'aria-label': 'Font'
};
export default Font;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Font.js
// module id = 3547
// module chunks = 11